<template>
  <v-checkbox v-bind="$attrs" color="input">
    <template v-slot:label>
      <div>{{ label }}</div>
    </template>
  </v-checkbox>
</template>

<script>
export default {
  name: "p-checkbox",
  props: {
    label: {
      type: String,
      default() {
        return "";
      },
    },
  },
};
</script>

<style scoped>
@import "./styles.css";
</style>
